import React from "react"
import "./TiempoExtraCard.css"
import IconBorder from "src/shared/components/data-display/IconBorder/IconBorder"
import Icon from "src/shared/icons"
import { COLLECTION } from "src/shared/icons/Icon"

const TiempoExtraCard = ({
    active,
    isStartState,
    icon,
    title,
    onClick
}: {
    active: boolean
    isStartState: boolean
    icon: keyof typeof COLLECTION | (string & {})
    title: string
    onClick: () => void
}) => {
    return (
        <div
            className="modal__personas-extra__card--container"
            onClick={onClick}
            style={{
                backgroundColor: isStartState ? "var(--white)" : active ? "var(--fondo-close)" : "var(--white)",
                border: isStartState
                    ? "2px solid var(--white)"
                    : active
                    ? "2px solid var(--purple-drawer-primario)"
                    : "2px solid var(--white)",
            }}
        >
            <div className="modal__personas-extra__card--check__wrapper">
                <div className="modal__personas-extra__card--check">
                    {isStartState ? (
                        <div className="modal__personas-extra__card--uncheck"></div>
                    ) : active ? (
                        <Icon name="checkFilled" width={18} height={18} color="var(--purple-drawer-primario)" />
                    ) : (
                        <div className="modal__personas-extra__card--uncheck"></div>
                    )}
                </div>
            </div>
            <div className="modal__personas-extra__card--header">
                <IconBorder
                    primaryBgColor={
                        isStartState
                            ? "var(--fondo-close)"
                            : active
                            ? "var(--purple-drawer-primario)"
                            : "var(--fondo-close)"
                    }
                    primaryBgDiameter={80}
                >
                    <Icon
                        name={icon}
                        width={50}
                        height={50}
                        color={
                            isStartState
                                ? "var(--purple-drawer-primario)"
                                : active
                                ? "var(--white)"
                                : "var(--purple-drawer-primario)"
                        }
                    />
                </IconBorder>
            </div>
            <div className="modal__personas-extra__card__footer">
                <span className={active ? "modal__personas-extra__card__title--active" : "modal__personas-extra__card__title"}>{title}</span>
            </div>
        </div>
    )
}

export default TiempoExtraCard
